import React from 'react';
import { SvgIcon } from "@mui/material";

const EditIcon = (props: any) => (
    <SvgIcon width="45" height="44" viewBox="0 0 45 44" fill="white" xmlns="http://www.w3.org/2000/svg" fontSize='large'>
        <path d="M28.4253 9.5926L34.908 16.0753L28.4253 9.5926ZM31.1753 6.8426C32.035 5.98295 33.2009 5.5 34.4167 5.5C35.6324 5.5 36.7983 5.98295 37.658 6.8426C38.5177 7.70226 39.0006 8.8682 39.0006 10.0839C39.0006 11.2997 38.5177 12.4656 37.658 13.3253L12.4167 38.5666H6V32.0179L31.1753 6.8426V6.8426Z" stroke="#F86464" stroke-width="3.14286" stroke-linecap="round" stroke-linejoin="round" fill='white' />
    </SvgIcon>);

export default EditIcon
